var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MgsInput',{attrs:{"type":"number","min":"0","value":_vm.$store.warenkorb.indexedEntries[_vm.biid] || 0},on:{"input":function($event){return _vm.$store.warenkorb.update(_vm.biid, $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }